import React from "react";
import LabelIcon from "@mui/icons-material/Label";
import LabelOffIcon from "@mui/icons-material/LabelOff";
import { useTranslation } from "react-i18next";
import PlayerFooterButton from "core/components/PlayerFooterButton";
import { useLabelsVisibility } from "core/hooks/useLabelsVisibility";

function LabelsToggleButton({ ...props }) {
  const { t } = useTranslation();
  const [labelsVisible, toggleLabelsVisibility] = useLabelsVisibility();

  const Icon = labelsVisible ? LabelIcon : LabelOffIcon;
  const tooltipText = labelsVisible
    ? t("player.hideLabels") || "Скрыть метки"
    : t("player.showLabels") || "Показать метки";

  return (
    <PlayerFooterButton
      title={tooltipText}
      onClick={toggleLabelsVisibility}
      style={{
        opacity: labelsVisible ? 1 : 0.6,
      }}
      {...props}
    >
      <Icon />
    </PlayerFooterButton>
  );
}

export default LabelsToggleButton;
